<template>
  <div>
      <div class="maincon">

        <div class="tab-tilte">
          <p @click="cur=1" :class="{active:cur==1}" style="cursor: pointer;">视频资源</p>
          <p @click="cur=2" :class="{active:cur==2}" style="cursor: pointer;">题库资源</p>
          <p @click="cur=0" :class="{active:cur==0}" style="margin-left: 0;cursor: pointer;">讲师资源</p>
        </div>
        <div class="tab-content">
          <yzteacher v-show="cur==0"></yzteacher>
          <yzvideo v-show="cur==1"></yzvideo>
          <yzsubject v-show="cur==2"></yzsubject>
        </div>

</div>
  </div>

</template>

<script>

  import Yzteacher from './Teacher.vue';
  import Yzvideo from './Video.vue';
  import Yzsubject from './Subject.vue';


  export default {
    data() {
      return {
        cur: 1,
      }
    },
    components: {
      yzteacher: Yzteacher,
      yzvideo: Yzvideo,
      yzsubject: Yzsubject,
    },
      methods: {

      },

  }
</script>

<style scoped>



  .maincon {
   padding: 20px;
   height: calc(100vh - 40px);
   overflow-y: auto;
  }

  .tab-tilte {
    height: 41px;
  }

  .tab-tilte>p {
    float: left;
    margin: 0 5px;
    padding: 10px 15px;
    background-color: white;
    border: 1px solid #DCDCDC;
    border-bottom: none;
    border-radius: 5px 5px 0 0;
    font-size: 15px;
  }

  .active {

    border-bottom: 1px solid white !important;
  }

  .tab-content {
    background-color: white;
    border: 1px solid #DCDCDC;
    min-height: calc(100% - 83px);
    border-radius: 0px 5px 5px 5px;
    padding: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/view/company/course/YzCourse/YzCourse.vue